import {
  Grid,
  FormControl,
  Box,
  TextField,
  CircularProgress,
  Typography,
  MenuItem,
  IconButton,
  Menu,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";

import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import MaterialTable from "material-table";
import {
  AddEmployeeEcmsAdjustmentAction,
  DeleteEmployeeEcmsAdjustmentAction,
  GetEmployeeEcmsAdjustmentAction,
  UpdateEmployeeEcmsAdjustmentAction,
} from "../../../../../store/Finance/PayEcms/Action";
import AddIcon from "@mui/icons-material/Add";
import GetAppIcon from "@mui/icons-material/GetApp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { month } from "../../../Base/helper/baseFunctions";
import * as XLSX from "xlsx";
import { PayPeriodDateHelper } from "../../helper/Reports/GetWageReportHelper";
import CommentIcon from "@mui/icons-material/Comment";
import { GetExitEmployeesHelper } from "../../../ECMSystem/helper/EcmsHelper";
import { GetECMSComponentsAction } from "../../../../../store/Finance/EcmsComponents/Action";
const PayEcmsEntry = () => {
  const dispatch = useDispatch();
  const date = new Date();

  const { ecms_components_data } = useSelector(
    (state) => state.FinanceReducer?.EcmsConfigFinanceReducer
  );
  const { employeeEcmsAdjustmentData, isLoadingEcmsComp} = useSelector(
    (state) => state?.FinanceReducer?.EcmsPayrunReducer
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [adjComponentData, setAdjComponentData] = useState({
    load: true,
    values: [],
  });

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
  });

  const handleEmployees = () => {
    GetExitEmployeesHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeesData({ load: false, values: res?.data?.data });
      } else {
        setEmployeesData({ load: false, values: [] });
      }
    });
  };

  const handleAdjComponents = (data) => {
    if (ecms_components_data) {
      const mappedData = (ecms_components_data || [])?.map((item) => ({
        label: item?.ecms_adjustments_configuration_json?.label,
        name: item?.ecms_adjustments_configuration_json?.name,
        taxable_flag: item?.taxable_flag || false,
        labelShow:
          `${item?.ecms_adjustments_configuration_json?.label} - ${
            item?.ecms_adjustments_configuration_json?.component_type ===
            "earning"
              ? "Earning"
              : "Deduction"
          }` || "",
        component_type:
          item?.ecms_adjustments_configuration_json?.component_type || "",
        ecms_adjustments_configuration_id:
          item?.ecms_adjustments_configuration_id,
        approver_id: item?.ecms_adjustments_configuration_json?.approver_id,
        approver_name: item?.ecms_adjustments_configuration_json?.approver_name  
      }));
      setAdjComponentData({ load: false, values: mappedData });
    }
  };

  const formatDataStructure = (data) => {
    if (!data || data.length === 0) return [];

    return data
      ?.map((employee) => {
        return {
          ...employee,
          employee_id: {
            employee_id: employee?.employee_id,
            name: employee?.employee_name,
          },
          ecms_adjustments_configuration_id: {
            ecms_adjustments_configuration_id:
              employee?.component_json?.ecms_adjustments_configuration_id,
            label: employee?.component_json?.label,
            name: employee?.component_json?.name,
            taxable_flag: employee?.component_json?.taxable_flag || false,
            labelShow: `${employee?.component_json?.label || ""} - ${
              employee?.component_type
            }`,
            component_type: employee?.component_json?.component_type || "",
          },
        };
      });
  };
  const adjustmentRows = formatDataStructure(employeeEcmsAdjustmentData) || [];
  const [payDate, setPayDate] = useState({
    start_date: "",
    end_date: "",
  });
  const [currentMonthPayPeriod, setCurrentMonthPayPeriod] = useState({
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    dispatch(GetEmployeeEcmsAdjustmentAction({ month: f_month, year: f_year }));
    dispatch(GetECMSComponentsAction());
    PayPeriodDateHelper({
      month: String(date?.getMonth() + 1),
      year: String(date?.getFullYear()),
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setPayDate(res?.data?.data?.[0]);
        setCurrentMonthPayPeriod(res?.data?.data?.[0]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    handleAdjComponents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecms_components_data]);
  const handleFilter = (event) => {
    if (["month_year"].includes(event?.target?.name)) {
      const updatedFilters = {
        ...filters,
        [event?.target?.name]: event?.target?.value,
      };
      setFilters(updatedFilters);
      const [f_year, month] = event?.target?.value.split("-");
      const f_month = parseInt(month, 10).toString();
      dispatch(
        GetEmployeeEcmsAdjustmentAction({ month: f_month, year: f_year })
      );
      PayPeriodDateHelper({
        month: f_month,
        year: f_year,
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          setPayDate(res?.data?.data?.[0]);
        }
      });
    }
  };

  const checkComponentType = (data) => {
    if (data === "deduction") {
      return "Deduction";
    } else if (data === "earning") {
      return "Earning";
    } else {
      return "";
    }
  };
  const handleSubmitRowData = (rowData, actionType) => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    if (actionType === "add") {
      dispatch(
        AddEmployeeEcmsAdjustmentAction({
          month: f_month,
          year: f_year,
          employee_fk: rowData?.employee_id?.employee_id,
          ecms_adjustment_component_json: JSON.stringify({
            ecms_adjustments_configuration_id:
              rowData?.ecms_adjustments_configuration_id
                ?.ecms_adjustments_configuration_id,
            label: rowData?.ecms_adjustments_configuration_id?.label,
            name: rowData?.ecms_adjustments_configuration_id?.name,
            taxable_flag: Boolean(
              rowData?.ecms_adjustments_configuration_id?.taxable_flag
            ),
            component_type:
              rowData?.ecms_adjustments_configuration_id?.component_type,
            amount: rowData?.amount,
            approver_date: null ,
            approver_amount: null ,
            approver_comments: null ,
            approver_status: null, 
            approver_id: rowData?.ecms_adjustments_configuration_id?.approver_id,
            approver_name: rowData?.ecms_adjustments_configuration_id?.approver_name,
            employee_id: rowData?.employee_id?.employee_id,
          }),
          component_type: checkComponentType(
            rowData?.ecms_adjustments_configuration_id?.component_type
          ),
          record_date: rowData?.record_date
            ? convertDateFormat(rowData?.record_date)
            : defaultDateValueBasedRange(
                payDate?.start_date,
                payDate?.end_date
              ),
          amount: rowData?.amount,
          comments: rowData?.comments || "",
        })
      );
    } else if (actionType === "edit") {
      dispatch(
        UpdateEmployeeEcmsAdjustmentAction({
          month: rowData?.month,
          year: rowData?.year,
          employee_ecms_adjustments_id: rowData?.employee_ecms_adjustments_id,
          employee_fk: rowData?.employee_id?.employee_id,
          ecms_adjustment_component_json: JSON.stringify({
            ecms_adjustments_configuration_id:
              rowData?.ecms_adjustments_configuration_id
                ?.ecms_adjustments_configuration_id,
            label: rowData?.ecms_adjustments_configuration_id?.label,
            name: rowData?.ecms_adjustments_configuration_id?.name,
            taxable_flag: Boolean(
              rowData?.ecms_adjustments_configuration_id?.taxable_flag
            ),
            component_type:
              rowData?.ecms_adjustments_configuration_id?.component_type,
            amount: rowData?.amount,
            approver_date: null ,
            approver_amount: null ,
            approver_comments: null ,
            approver_status: null, 
            approver_id: rowData?.ecms_adjustments_configuration_id?.approver_id,
            approver_name: rowData?.ecms_adjustments_configuration_id?.approver_name,
            employee_id: rowData?.employee_id?.employee_id,          }),
          component_type: checkComponentType(
            rowData?.ecms_adjustments_configuration_id?.component_type
          ),
          record_date: rowData?.record_date,
          amount: rowData?.amount,
          comments: rowData?.comments || "",
        })
      );
    } else if (actionType === "delete") {
      dispatch(
        DeleteEmployeeEcmsAdjustmentAction({
          employee_ecms_adjustments_id: rowData?.employee_ecms_adjustments_id,
          month: f_month,
          year: f_year,
        })
      );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };
  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleExportCSV = async (downloadType, adjComp) => {
    const [f_year, month_value] = filters?.month_year.split("-");
    let fileName = "ECMS Adjustments.csv";
    let headers = [];

    if (downloadType === "actual-data") {
      handleMenuClose();
      setLoading(true);
      fileName =
        `ECMS Adjustments_${month[month_value - 1]}_${f_year}.csv` ||
        "ECMS Adjustments.csv";
      headers = ["Pay Date", "Employee Name", "Adjustment Component", "Amount", "Comment"];
    }

    try {
      let csvData = [];
      if (downloadType === "actual-data") {
        csvData = [
          headers,
          ...adjustmentRows?.map((row) => [
            row?.record_date,
            row?.employee_id?.name || "",
            row?.ecms_adjustments_configuration_id?.labelShow || "",
            row?.amount || "",
            row?.comments || "",
          ]),
        ];
      }
      const ws = XLSX.utils.aoa_to_sheet(csvData);
      const csv = XLSX.utils.sheet_to_csv(ws);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("CSV Export Failed:", error);
    } finally {
      setLoading(false);
      handleMenuClose();
    }
  };

  const handleExportPDF = () => {
    setMenuAnchor(null);
    setLoading(true);
    setTimeout(() => {
      try {
        const doc = new jsPDF();
        doc.text("ECMS Adjustments", 14, 10);
        const tableHeaders = [
          ["Pay Date", "Employee Name", "Adjustment Component", "Amount", "Comment"],
        ];
        const tableBody = adjustmentRows?.map((row) => [
          row?.record_date,
          row?.employee_id?.name || "N/A",
          row?.ecms_adjustments_configuration_id?.labelShow || "N/A",
          row?.amount || "0",
          row?.comments || "",
        ]);

        doc.autoTable({
          head: tableHeaders,
          body: tableBody,
        });
        const [f_year, month_value] = filters.month_year.split("-");
        const fileName =
          `ECMS Adjustments_${month[month_value - 1]}_${f_year}.pdf` ||
          "ECMS Adjustments.pdf";
        doc.save(fileName);
      } catch (error) {
        console.error("PDF Export Failed:", error);
      } finally {
        setLoading(false);
      }
    }, 0);
  };
  const disableBeyondPayPeriod = () => {
    const currentPeriodDate = new Date(currentMonthPayPeriod?.start_date);
    const filterPeriodDate = new Date(payDate?.end_date);
    return filterPeriodDate > currentPeriodDate;
  };
  const defaultDateValueBasedRange = (startDate, endDate) => {
    const today = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (today >= start && today <= end) {
      return convertDateFormat(today);
    } else {
      return convertDateFormat(end);
    }
  };
  const convertDateFormat = (date) => {
    // always accept argument as new Date() object
    if (!date) return "";
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`; // Return formatted date string
  };

  return (
    <Box
      sx={{
        maxHeight: "calc(100vh - 115px)",
        overflowY: "auto",
      }}
    >
      <Grid
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
        }}
        pt={1.5}
        pb={1}
        container
      >
        <Grid pr={1} item xs={12} sm={2.5}>
          <FormControl fullWidth>
            <CommonDatePicker
              name="month_year"
              openTo="month"
              views={["year", "month"]}
              label="Month and Year"
              pickerType="date"
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onKeyPress={(e) => e.preventDefault()}
              pickerFormat="MM/yyyy"
              DefaultDTvalue={filters.month_year}
              // minDate={new Date(new Date(minDojYear).getFullYear(), 0, 31)}
              minDate={new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1))}
              maxDate={
                new Date(new Date().getFullYear(), new Date().getMonth() + 6, 1)
              }
              handleChange={(value) =>
                handleFilter({
                  target: {
                    name: "month_year",
                    value: value
                      ? `${value?.getFullYear()}-${(
                          "0" +
                          (value?.getMonth() + 1)
                        ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                      : "",
                  },
                })
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box
      // sx={{
      //   height: "calc(100vh - 143px)",
      //   overflowY: "auto",
      // }}
      >
        <MaterialTable
          key={filters?.month_year}
          isLoading={isLoadingEcmsComp}
          columns={[
            {
              title: "Pay Date",
              headerStyle: {
                width: "15%",
                textAlign: "start",
                paddingLeft: "2%",
                cursor: "pointer",
              },
              cellStyle: {
                width: "15%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              field: "record_date",
              grouping: false,
              editComponent: (props) => {
                const isEdit = props.rowData?.tableData?.editing === "update";
                return (
                  <Box sx={{ width: "115%", ml: -2 }}>
                    <FormControl fullWidth>
                      <CommonDatePicker
                        disabled={isEdit}
                        size="small"
                        name="record_date"
                        label="Pay Date"
                        pickerType="date"
                        onKeyPress={(e) => e.preventDefault()}
                        onKeyDown={(e) => e.preventDefault()}
                        required={true}
                        pickerFormat="dd/MM/yyyy"
                        DefaultDTvalue={
                          props.value
                            ? props.value
                            : defaultDateValueBasedRange(
                                payDate?.start_date,
                                payDate?.end_date
                              )
                        }
                        minDate={payDate?.start_date}
                        maxDate={payDate?.end_date}
                        handleChange={(value) => {
                          props.onChange(value);
                        }}
                      />
                    </FormControl>
                  </Box>
                );
              },
            },
            {
              title: "Employee",
              headerStyle: {
                width: "25%",
                textAlign: "start",
                paddingLeft: "2%",
                cursor: "pointer",
              },
              cellStyle: {
                width: "25%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              field: "employee_id",
              grouping: false,
              customSort: (a, b) => (a.employee_id?.name || "").localeCompare(b.employee_id?.name || ""),
              validate: (rowData) => {
                if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
                if (rowData.employee_id?.name) {
                  return "";
                } else {
                  return "Employee cannot be empty";
                }
              },
              render: (rowData) => rowData.employee_id?.name || "",
              editComponent: (props) => {
                const isEdit = props.rowData?.tableData?.editing === "update";
                return (
                  <Box sx={{ width: "100%" }}>
                    <SelectableSearch
                      fullWidth
                      variantType="standard"
                      size="small"
                      disabled={isEdit}
                      loading={() => handleEmployees()}
                      placeholder="Select Employee"
                      value={props.value}
                      fieldLabel="name"
                      name="employee_id"
                      onChangeEvent={(e, v) => {
                        props.onChange(v);
                      }}
                      data={employeesData}
                    />
                  </Box>
                );
              },
              customFilterAndSearch: (search, rowData) =>
                (rowData?.employee_id?.name || "")
                  .toLowerCase()
                  .includes(search.toLowerCase()),
            },
            {
              title: "Adjustment Component",
              headerStyle: {
                width: "25%",
                textAlign: "start",
                paddingLeft: "2%",
                cursor: "pointer",
              },
              cellStyle: {
                width: "25%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              field: "ecms_adjustments_configuration_id",
              grouping: false,
              customSort: (a, b) => (a.ecms_adjustments_configuration_id?.labelShow || "").localeCompare(b.ecms_adjustments_configuration_id?.labelShow || ""),
              validate: (rowData) => {
                if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
                if (rowData.ecms_adjustments_configuration_id?.label) {
                  return "";
                } else {
                  return "Adjustment Component cannot be empty";
                }
              },
              render: (rowData) =>
                rowData.ecms_adjustments_configuration_id?.labelShow || "",
              editComponent: (props) => {
                return (
                  <Box sx={{ width: "95%" }}>
                    <SelectableSearch
                      fullWidth
                      required
                      variantType="standard"
                      size="small"
                      loading={() =>
                        handleAdjComponents(props.rowData?.employee_id)
                      }
                      placeholder="Select Component"
                      value={props.value || ""}
                      fieldLabel="labelShow"
                      name="ecms_adjustments_configuration_id"
                      onChangeEvent={(e, v) => {
                        props.onChange(v);
                      }}
                      data={adjComponentData}
                    />
                  </Box>
                );
              },
            },
            {
              title: "Amount",
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              headerStyle: {
                width: "12%",
                textAlign: "start",
                paddingLeft: "2%",
                cursor: "pointer",
              },
              field: "amount",
              grouping: false,
              validate: (rowData) => {
                if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
                if (rowData?.amount) {
                  return "";
                } else {
                  return "Amount cannot be empty";
                }
              },
              editComponent: (props) => {
                return (
                  <Box width={"100%"}>
                    <TextField
                      required={true}
                      type="number"
                      variant="standard"
                      placeholder="Enter Amount"
                      value={props?.value}
                      inputProps={{ min: 0 }}
                      onChange={(e) => {
                        if (Number(e.target.value) < 0) return;
                        props.onChange(e.target.value);
                      }}
                    />
                  </Box>
                );
              },
            },
            {
              title: "Comment",
              headerStyle: {
                width: "18%",
                textAlign: "center",
                paddingLeft: "2%",
                cursor: "default",
              },
              cellStyle: {
                width: "18%",
                textAlign: "center",
                padding: "5px 0px 0px 2%",
              },
              field: "comments",
              grouping: false,
              sorting: false,
              render: (rowData) => {
                return (
                  <Box width={"90%"} onClick={(e) => e.stopPropagation()}>
                    <Tooltip title={rowData.comments || ""} arrow>
                      <CommentIcon
                        sx={{
                          fontSize: "20px",
                          color: rowData.comments ? "#637381" : "#95a0ab",
                          cursor: rowData.comments ? "pointer" : "default",
                        }}
                      />
                    </Tooltip>
                  </Box>
                );
              },
              editComponent: (props) => {
                return (
                  <Box width={"100%"}>
                    <TextareaAutosize
                      minRows={1}
                      maxRows={1}
                      placeholder={"Comment"}
                      value={props.value || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 50) {
                          props.onChange(value);
                        }
                      }}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        padding: "8px",
                        fontSize: "14px",
                        fontFamily: "inherit",
                        border: "1px solid #ccc",
                        resize: "none",
                      }}
                    />

                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "right",
                        color: "#888",
                      }}
                    >
                      {props.rowData?.comments?.length || 0}/50
                    </Typography>
                  </Box>
                );
              },
            },
          ]}
          data={adjustmentRows}
          options={{
            maxBodyHeight: "calc(100vh - 300px)",
            minBodyHeight: "calc(100vh - 300px)",
            rowStyle: { fontSize: "13px", height: "30px" },
            headerStyle: {
              padding: "7px 0px 7px 0px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: false,
          }}
          icons={{
            Add: () =>
              disableBeyondPayPeriod() && <AddIcon sx={{ color: "#637381" }} />,
            Edit: () =>
              disableBeyondPayPeriod() && (
                <EditIcon sx={{ color: "#637381" }} />
              ),
            Delete: () =>
              disableBeyondPayPeriod() && (
                <DeleteIcon sx={{ color: "#637381" }} />
              ),
          }}
          editable={{
            onRowAdd: !disableBeyondPayPeriod()
              ? null
              : (newRow) =>
                  new Promise((resolve, reject) => {
                    handleSubmitRowData(newRow, "add");
                    setTimeout(() => resolve(), 500);
                  }),
            onRowUpdate: !disableBeyondPayPeriod()
              ? null
              : (newRow, oldRow) =>
                  new Promise((resolve, reject) => {
                    handleSubmitRowData(newRow, "edit");
                    setTimeout(() => resolve(), 500);
                  }),
            onRowDelete: !disableBeyondPayPeriod()
              ? null
              : (selectedRow) =>
                  new Promise((resolve, reject) => {
                    handleSubmitRowData(selectedRow, "delete");
                    setTimeout(() => resolve(), 1000);
                  }),
          }}
          actions={[
            {
              icon: () => (
                <IconButton
                  sx={{
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress color="inherit" size={24} disableShrink />
                  ) : (
                    <GetAppIcon />
                  )}
                </IconButton>
              ),
              tooltip: "Export",
              isFreeAction: true,
              onClick: (event) => handleMenuOpen(event),
              hidden: employeeEcmsAdjustmentData?.length === 0,
            },
          ]}
          title=""
        />
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={() => handleExportCSV("actual-data")}>
            Export as CSV
          </MenuItem>
          <MenuItem onClick={handleExportPDF}>Export as PDF</MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default PayEcmsEntry;
